<template>
  <el-dialog
    title="商品打标"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleClose"
  >
    <el-form :model="addProductLabelInfo" label-width="100px">
      <el-form-item label="选择标签">
        <el-select 
          v-model="addProductLabelInfo.labelCd" 
          placeholder="请选择商品标签"
          style="width:100%"
        >
          <el-option 
            v-for="(item,index) in addProductLabelInfo.labels"
            :key="index"
            :label="item.labelName"
            :value="item.labelCd"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="saveProductLabelInfo">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveProductLabel, queryLabel } from '@/api/goods/productApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddProductLabel',
  data() {
    return {
      dialogVisible: false,
      addProductLabelInfo: {
        labelCd: '',
        productId: '',
        labels: []
      }
    }
  },
  created() {
    this._listLabels()
  },
  methods: {
    open(product) {
      this.addProductLabelInfo.productId = product.productId
      this.dialogVisible = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    addProductLabelValidate() {
      if (!this.addProductLabelInfo.labelCd) {
        this.$message.error('请选择标签')
        return false
      }
      if (!this.addProductLabelInfo.productId) {
        this.$message.error('产品不能为空')
        return false
      }
      return true
    },
    async saveProductLabelInfo() {
      if (!this.addProductLabelValidate()) return
      
      try {
        const params = {
          ...this.addProductLabelInfo,
          shopId: getShopId()
        }
        const res = await saveProductLabel(params)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.clearAddLabelInfo()
          this.$router.push(`/pages/goods/productLabelManage?productId=${this.addProductLabelInfo.productId}`)
        } else if (res.code === 404) {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('保存标签失败:', error)
        this.$message.error('保存失败')
      }
    },
    clearAddLabelInfo() {
      this.addProductLabelInfo = {
        labelCd: '',
        productId: '',
        labels: []
      }
    },
    async _listLabels() {
      try {
        const params = {
          page: 1,
          row: 100,
          shopId: getShopId(),
          hasSystem: 'Y'
        }
        const res = await queryLabel(params)
        this.addProductLabelInfo.labels = res.data
      } catch (error) {
        console.error('获取标签列表失败:', error)
      }
    }
  }
}
</script>